export class PAReviewSearchModel {
    constructor() {
        this.columnFilters = [];
        this.cycleFilters = null;
        this.showActionableItem = false;
    }
}
export default class PAReviewSearch extends PAReviewSearchModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
